import React from 'react'
import "./exploreIndia.css"

const ExploreIndia = () => {
  return (
    <div className='explore'>
      <div className="exploreItem">
        <img src="https://cf.bstatic.com/xdata/images/city/square250/684534.webp?k=d1fe86c22f2433f4e2dda14ddcbe80feb024b0fb30305e5684a1241fba5d4cff&o=" alt="" className="exploreImg" />
        <div className="exploreTitle">
            <h1>Banglore</h1>
            <h3>2041 properties</h3>
        </div>
      </div>

      <div className="exploreItem">
        <img src="https://cf.bstatic.com/xdata/images/city/square250/684682.webp?k=30cf9de93f2a0f87eed7d2d0d9b3e6eccd5dcf3a4b68b4e0151c0800ddc84af7&o=" alt="" className="exploreImg" />
        <div className="exploreTitle">
            <h1>Lonavela</h1>
            <h3>771 properties</h3>
        </div>
      </div>

      <div className="exploreItem">
        <img src="https://cf.bstatic.com/xdata/images/region/square250/49646.webp?k=b7f38878b9164ee38e0b99c4d4646dbea76b7bf4add8464b1aa75e4c9d0efc6e&o=" alt="" className="exploreImg" />
        <div className="exploreTitle">
            <h1>Goa</h1>
            <h3>5244 properties</h3>
        </div>
      </div>

      <div className="exploreItem">
        <img src="https://cf.bstatic.com/xdata/images/city/square250/684765.webp?k=3f7d20034c13ac7686520ac1ccf1621337a1e59860abfd9cbd96f8d66b4fc138&o=" alt="" className="exploreImg" />
        <div className="exploreTitle">
            <h1>New Delhi</h1>
            <h3>2991 properties</h3>
        </div>
      </div>

      <div className="exploreItem">
        <img src="https://cf.bstatic.com/xdata/images/city/square250/684622.webp?k=f9eacb40b8f7c8560afc74cdcfe2e7028e5117a36a0d8d3356f735ea3ac20f4f&o=" alt="" className="exploreImg" />
        <div className="exploreTitle">
            <h1>Gurgaon</h1>
            <h3>1304 properties</h3>
        </div>
      </div>

      <div className="exploreItem">
        <img src="https://cf.bstatic.com/xdata/images/city/square250/684501.webp?k=225f7713b3f47f0c2c580c34c35582ba70331757bcc8dc32e7f17072c80805ff&o=" alt="" className="exploreImg" />
        <div className="exploreTitle">
            <h1>Agra</h1>
            <h3>441 properties</h3>
        </div>
      </div>
    </div>
  )
}

export default ExploreIndia
